import React, { useState, useEffect, useRef, useCallback} from 'react';
import {  differenceInMinutes, fromUnixTime, getUnixTime } from 'date-fns';
import Popup from './common/components/popup';

  
const SessionTimeout = () => {
  const [events, setEvents] = useState(['click', 'load', 'scroll']);  // eslint-disable-line
    const [showModal, setShowModal] = useState(false);

    let warningInactiveInterval = useRef();
    let startTimerInterval = useRef();

    //check if the user is idle
  let timeChecker = () => { // eslint-disable-line
        startTimerInterval.current = setTimeout(() => {
            let storedTimeStamp = sessionStorage.getItem('lastTimeStamp');
            clearInterval(warningInactiveInterval.current);
            warningInactive(storedTimeStamp);
        }, 60000); //keep check after a minute of event
    };

    // check if timeout is happened 
    let warningInactive = (timeString) => {
        clearTimeout(startTimerInterval.current);

        warningInactiveInterval.current = setInterval(() => {
            const now = new Date().getTime();
            const storedTime = Number(timeString);

            const storedDateTime = fromUnixTime(getUnixTime(storedTime));
            const currentDateTime = fromUnixTime(getUnixTime(now)); 
      
            const minPast = differenceInMinutes(currentDateTime, storedDateTime);

            if(minPast >= 20)
            {
                setShowModal(true);
            }
        }, 1000);// keep check every second
    };

    // reset interval timer
  let resetTimer = useCallback(() => {  // eslint-disable-line
        clearTimeout(startTimerInterval.current);
        clearInterval(warningInactiveInterval.current);

        const timeStamp = new Date().getTime();

        sessionStorage.setItem('lastTimeStamp', timeStamp);
    
        timeChecker();
        setShowModal(false);
    });

    useEffect(() => {
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        const timeStamp = new Date().getTime();
        sessionStorage.setItem('lastTimeStamp', timeStamp);
        timeChecker();

        return () => {
            clearTimeout(startTimerInterval.current);
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [resetTimer, events, timeChecker]);

    return (
        <Popup 
            showModal={showModal}
        />
    )
};

export default SessionTimeout;

